export const pageTitles = [
  {
    title: 'Users',
    basePath: '/users',
  },
  {
    title: 'User Groups',
    basePath: '/groups',
  },
  {
    title: 'API Keys',
    basePath: '/apikeys',
  },
];
